import React, { useState, useEffect }  from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { makeStyles } from '@mui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
} from '@mui/material';


import { options } from './chart';


import moment from 'moment';
import palette from 'theme/palette';

const useStyles = makeStyles(() => ({
  root: {},
  chartContainer: {
    height: 400,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));


const LatestOrders = props => {
  const { className, localOrders, onlineOrders, ...rest } = props;

  const classes = useStyles();
  const [data, setData] = useState({});


const buildDataSet = () => {
 
  
  const labelList = localOrders.map(item => moment(item.day).format('D MMM'));
  setData( {
    labels: labelList,
    datasets: [
      {
        label: 'Online Orders',
        backgroundColor: palette.primary.main,
        data: onlineOrders.map(item => item.count)
      }, 

      {
        label: 'Local Orders',
        backgroundColor: palette.secondary.main,
        data: localOrders.map(item => item.count)
      }, 
    ]
  });
};


useEffect(() => {
  buildDataSet();
  
}, [props]);


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        // action={
        //   <Button
        //     size="small"
        //     variant="text"
        //   >
        //     Last 7 days <ArrowDropDownIcon />
        //   </Button>
        // }
        title="Latest Order Counts"
      />
      <Divider />
      <CardContent>
        <div className={classes.chartContainer}>
          {data && data.labels && data.datasets ? (
            <Bar
              key={`latest-orders-chart-${JSON.stringify(data.labels)}`}
              data={data}
              options={options}
            />
          ) : (
            <div>Loading chart...</div>
          )}
        </div>
      </CardContent>
      <Divider />
      {/* <CardActions className={classes.actions}>
        <Button
          color="primary"
          size="small"
          variant="text"
        >
          Overview <ArrowRightIcon />
        </Button>
      </CardActions> */}
    </Card>
  );
};

LatestOrders.propTypes = {
  className: PropTypes.string
};

export default LatestOrders;
